import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import ChatIcon from "@mui/icons-material/Chat";
import CommentsDisabledIcon from "@mui/icons-material/CommentsDisabled";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Model from "../products/Model";
import Estructuras from "../../assets/images/models/Estructuras.js";
import Pasarela from "../../assets/images/models/Pasarela.js";
import Vigas from "../../assets/images/models/Vigas.js";
import Tribunas from "../../assets/images/models/Tribunas.js";
import EstructuraThumbnail from "../../assets/images/icons/estructuras-white.svg";
import PasarelaThumbnail from "../../assets/images/icons/pasarelas-white.svg";
import VigasThumbnail from "../../assets/images/icons/vigas-white.svg";
import TribunasThumbnail from "../../assets/images/icons/tribunas-white.svg";

const Galeria3DModels = ({ nameProd, desktop }) => {
  const [show, setShow] = useState(false);
  const handleclose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [descripcionContainer, setDescripcionContainer] = useState(false);

  const modelosReel = [
    {
      _id: 1,
      name: "Estructuras",
      url: Estructuras,
      description: "Estructura modelo 3d",
      thumbnail: EstructuraThumbnail,
    },
    {
      _id: 2,
      name: "Pasarelas",
      url: Pasarela,
      description: "Pasarela modelo 3d",
      thumbnail: PasarelaThumbnail,
    },
    {
      _id: 3,
      name: "Vigas",
      url: Vigas,
      description: "Viga modelo 3d",
      thumbnail: VigasThumbnail,
    },
    {
      _id: 4,
      name: "Tribunas",
      url: Tribunas,
      description: "Tribuna modelo 3d",
      thumbnail: TribunasThumbnail,
    },
  ];
  const modeloActual = modelosReel?.filter(
    (modelo) => modelo.name.toLowerCase() === nameProd?.toLowerCase() && modelo
  );
  const [model, setModel] = useState({
    model: modeloActual[0]?.url ? modeloActual[0]?.url : "",
    description: modeloActual[0]?.description
      ? modeloActual[0]?.description
      : "",
    name: modeloActual[0]?.name ? modeloActual[0]?.name : "",
  });

  const MostrarDescripcion = () => {
    setDescripcionContainer(!descripcionContainer);
  };

  return (
    <>
      {modeloActual[0] ? (
        <>
        {!desktop &&
          <div
            onClick={handleShow}
            className="description_mobile ficha-tecnica-button text-center"
          >
            Galeria 3D <ArrowDownwardIcon />
          </div>
          }
          {desktop &&
          <div
            onClick={handleShow}
            id="boton-galeria2"
            className="description_desktop boton-galeria2"
          >
            {/* <PhotoIcon /> */}
            <ThreeDRotationIcon />
            <p className="p-galeria"> GALERIA 3D</p>
          </div>
          }
        </>
      ) : (
        ""
      )}
      <Offcanvas
        show={show}
        onHide={handleclose}
        placement="end"
        className="offcanvas-fullpage"
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <ul className="thumb-galery">
            {modelosReel.map(
              (modelo, index) =>
                modelo.name.toLowerCase() === nameProd.toLowerCase() && (
                  <li className="thumb-galery-list--item" key={index}>
                    <figure>
                      <img
                        className={modelo.url === model.model ? "active" : ""}
                        src={modelo.thumbnail}
                        alt={`modelo-${index}`}
                        onClick={() =>
                          setModel({
                            model: modelo.url,
                            name: modelo.name,
                            description: modelo.description,
                          })
                        }
                        loading="lazy"
                      />
                    </figure>
                  </li>
                )
            )}
          </ul>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="description-container">
            <div
              id="model-focus__description"
              className={
                descripcionContainer ? "model-focus__description" : "d-none"
              }
            >
              <p>{model.description}</p>
            </div>
            <span
              onClick={MostrarDescripcion}
              className={
                descripcionContainer
                  ? "mostrar_descripcion active"
                  : "mostrar_descripcion"
              }
            >
              {descripcionContainer ? <CommentsDisabledIcon /> : <ChatIcon />}
            </span>
          </div>
          <Model Item={model.model} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Galeria3DModels;
